class GloweCustomCollar extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[name="properties[Personalisation]"]');
    this.counter = this.querySelector('[data-personalisation-counter]');
    this.helper = this.querySelector('[data-personalisation-helper]');
    this.error = this.querySelector('[data-personalisation-error]');
    this.productSection = this.closest('.shopify-section');
    this.variantPicker =
      this.productSection?.querySelector('variant-picker[data-template-product-match="true"]') ||
      this.productSection?.querySelector('variant-picker');
    this.productForm = this.productSection?.querySelector('product-form-component form[data-type="add-to-cart-form"]');

    if (!this.input || !this.variantPicker || !this.productForm) return;

    this.input.addEventListener('input', this.handleInput);
    this.input.addEventListener('blur', this.handleBlur);
    this.input.addEventListener('invalid', this.handleInvalid);
    this.variantPicker.addEventListener('change', this.handleLengthChange);
    this.productForm.addEventListener('click', this.handleAddClick, true);
    this.productForm.addEventListener('submit', this.handleSubmit, true);

    this.updateLimit();
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.handleInput);
    this.input?.removeEventListener('blur', this.handleBlur);
    this.input?.removeEventListener('invalid', this.handleInvalid);
    this.variantPicker?.removeEventListener('change', this.handleLengthChange);
    this.productForm?.removeEventListener('click', this.handleAddClick, true);
    this.productForm?.removeEventListener('submit', this.handleSubmit, true);
  }

  handleInput = () => {
    if (this.input.value.length > this.input.maxLength) {
      this.input.value = this.input.value.trim().slice(0, this.input.maxLength);
    }
    const isWhitespaceOnly = this.input.value.length > 0 && !this.input.value.trim().length;
    this.input.setCustomValidity(isWhitespaceOnly ? 'Please enter the text you would like on the collar.' : '');
    this.updateCounter();
    this.clearError();
  };

  handleBlur = () => {
    if (!this.input.value.trim().length) this.showRequiredError();
  };

  handleInvalid = (event) => {
    event.preventDefault();
    this.showRequiredError();
  };

  handleAddClick = (event) => {
    if (!event.target.closest('[name="add"], button[type="submit"], input[type="submit"]')) return;
    if (this.validate()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  };

  handleSubmit = (event) => {
    if (this.validate()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  };

  validate() {
    const trimmedValue = this.input.value.trim();
    if (trimmedValue.length) {
      this.input.value = trimmedValue.slice(0, this.currentLimit());
      this.updateCounter();
      return true;
    }

    this.showRequiredError();
    this.input.focus();
    this.input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  handleLengthChange = (event) => {
    if (this.normalizeName(event.target?.dataset?.optionName) !== 'characterlength') return;
    this.updateLimit();
  };

  updateLimit() {
    const limit = this.currentLimit();
    this.input.maxLength = limit;
    if (this.input.value.length > limit) this.input.value = this.input.value.slice(0, limit);
    if (this.helper) this.helper.textContent = `Maximum ${limit} characters`;
    this.input.setCustomValidity('');
    this.clearError();
    this.updateCounter();
  }

  currentLimit() {
    const selected = this.lengthControls().find(
      (control) =>
        (control instanceof HTMLInputElement && control.checked) ||
        (control instanceof HTMLOptionElement && control.selected)
    );
    const selectedValue = this.normalize(selected?.value);
    return selectedValue === this.normalize(this.dataset.tierTwo) ? 10 : 5;
  }

  updateCounter() {
    const count = this.input.value.length;
    if (this.counter) this.counter.textContent = `${count} / ${this.input.maxLength}`;
  }

  lengthControls() {
    return [...this.variantPicker.querySelectorAll('[data-option-name]')].filter(
      (control) => this.normalizeName(control.dataset.optionName) === 'characterlength'
    );
  }

  showRequiredError() {
    const message = 'Please enter the text you would like on the collar.';
    this.input.setCustomValidity(message);
    this.showError(message);
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = false;
    this.input.setAttribute('aria-invalid', 'true');
  }

  clearError() {
    if (!this.error) return;
    this.error.textContent = '';
    this.error.hidden = true;
    this.input.setAttribute('aria-invalid', 'false');
  }

  normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[–—−]/g, '-')
      .replace(/\s*-\s*/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  normalizeName(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }
}

if (!customElements.get('glowe-custom-collar')) {
  customElements.define('glowe-custom-collar', GloweCustomCollar);
}
